import { Box, Stack } from '@mui/material'
import React from 'react'
import { dayNames } from '@fedsim/helpers'
import ShowIcon from '@mui/icons-material/CalendarToday'

import { Caption, CostRow, HeaderTertiary, Special } from '../../typography'
import { ImageBlock } from '../../image-block'
import Chip from '../../chip'
import { AvatarStack } from '../../namebar';
import { SPACING } from '../../typography'

const showItems = (title = '', items = []) =>
  (items.length > 0 && (
    <Caption sx={{ mr: 2 }}>
      <strong>{title}</strong>: {items.map(item => item.name).join(',')}
    </Caption>
  )) ||
  null

const getOrdinalNum = n =>
  n +
  (n > 0
    ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10]
    : '')

export function ShowBlock(props) {
  const {
    brands = [],
    authority = [],
    commentators = [],
    interviewers = [],
    weekly = true,
    monthly = false,
    yearly = false,
    dayIndex = false,
    special = false,
    income = 0
  } = props
  // const broacastType = special ? 'Global Broadcast' : 'Network'
  let returnString = ''
  let suffix = `${dayNames[dayIndex]}`
  if (weekly) {
    returnString = 'Weekly'
  }
  if (monthly) {
    returnString = 'Monthly'
  }
  if (yearly) {
    returnString = 'Yearly'
    suffix = `Day ${getOrdinalNum(dayIndex)}`
  }
  return (
    <>
      <Stack spacing={SPACING}>
        <AvatarStack collection={brands} />
        <Chip label={`${suffix} - ${returnString}`} avatar={<ShowIcon />} />
        <Special value={special} />
        <CostRow label="Income" value={income} />
        {showItems('Authority', authority)}
        {showItems('Commentators', commentators)}
        {showItems('Interviewers', interviewers)}
      </Stack>
    </>
  )
}
export const ShowItem = props => {
  const {
    children,
    image = '',
    cardImage = '',
    name,
    backgroundColor,
    color
  } = props
  {
    const backgroundImage = `url(${cardImage}) cover no-repeat`

    return (
      <Stack sx={{ color }} alignItems='center' direction='row' spacing={SPACING}>
        <ImageBlock image={image} backgroundColor={backgroundColor} />
        <Stack sx={{ color, minWidth: 230 }} spacing={0.5}>
          <HeaderTertiary>{name}</HeaderTertiary>
          <ShowBlock {...props} />
        </Stack>
        <Box
          sx={{
            display: 'block',
            backgroundImage,
            height: '100%',
            width: '100%'
          }}
        />
        {children}
      </Stack>
    )
  }
}
